// extracted by mini-css-extract-plugin
module.exports = {"SequenceCell":"SequenceCell_SequenceCell__1P7mV","Centered":"SequenceCell_Centered__3gbHx","Centerer":"SequenceCell_Centerer__1XJmB"};